import { Component, OnInit, Inject, Input, ChangeDetectionStrategy } from '@angular/core';
import { SimDataService } from '../../services/sim-data.service';
import { Observable, BehaviorSubject, merge, of, from } from 'rxjs';
import { SimWithUsage, Sim } from '../../models/sim';
import { switchMap, mergeMap, toArray } from 'rxjs/operators';

@Component({
  selector: 'app-train-sims-usage',
  template: require('./train-sims-usage.component.html'),
  styles: [require('./train-sims-usage.component.sass')],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TrainSimsUsageComponent implements OnInit {

  @Input() projectId: number;
  @Input() trainId: number;

  trainSims$: Observable<SimWithUsage[] | null>;
  private readonly refreshTrainSimsList$ = new BehaviorSubject(undefined);
  
  constructor(
    @Inject('ProjectService') private projectService: any,
    @Inject('TimeZoneFactory') private timeZoneFactory: any,
    private simDataService: SimDataService
  ) { 

      this.trainSims$ = this.refreshTrainSimsList$.pipe(
      switchMap(() => merge(
        of(null),
        this.simDataService.getSimsByTrain(this.projectId, this.trainId).pipe(
          mergeMap((sims: Sim[]) => 
            // `from` emits each contact separately 
            from(sims).pipe(
              // load each contact
              mergeMap(
                sim => {
                const period = this.timeZoneFactory.formatUtcToBackendPeriod(sim.simConfig.currentBeginPeriod, sim.simConfig.currentEndPeriod);
                 return  this.simDataService.getSimUsage(
                  this.projectId,
                  sim.iccid,
                  period.start,
                  period.end
                )
              },
                // in result selector, connect fetched detail 
                (sim, simUsage) => ({
                  ...sim, 
                  ...simUsage
                })
              ),
              // collect all contacts into an array
              toArray()
            )
        ),
        )
    )))
  }

  ngOnInit(): void {
  }

  reload = () => {
    this.refreshTrainSimsList$.next(undefined);
  }

}
